export const translations = {
  search: {
    placeholder: "Paieška...",
    clearLabel: "Išvalyti",
    searchLabel: "Ieškoti",
  },
  error: {
    title: "Klaida",
    retry: "Bandyti dar kartą",
    close: "Uždaryti",
    generic: "Įvyko klaida. Prašome bandyti vėliau.",
  },
  common: {
    filter: "Filtruoti",
    save: "Išsaugoti",
    cancel: "Atšaukti",
    close: "Uždaryti",
  },
  notFound: {
    title: '404 - Page Not Found',
    message: 'Nieko čia nėra',
    goHome: 'Grįžti į pradžią'
  },
  forbidden: {
    title: 'Ups...',
    message: 'Jūs neturite teisės pasiekti šio puslapio. Prašome susisiekti su administratoriumi.',
    logout: 'Atsijungti',
  },
  home: {
    filter: 'Filtruoti',
    reminders: 'Priminimai',
    editReminders: 'Redaguoti priminimų sąrašą',
    editClients: 'Redaguoti klientų būsenas',
    closeDrawer: 'Uždaryti filtrų skydelį'
  },
  clientState: {
    modalTitle: 'Kliento statuso keitimo forma',
    label: 'Kliento statusas',
    required: 'Statusas yra privalomas',
    success: (count: number) => `Sėkmingai atnaujinti ${count} klientai`,
    error: 'Įvyko klaida atnaujinant klientų statusą',
    cancel: 'Atšaukti',
    save: 'Išsaugoti'
  },
  clientControls: {
    newProforma: 'Nauja išankstinė sąskaita',
    lastProforma: (date: string) => `Paskutinė išrašyta SIA \n ${date}`,
    newReminder: 'Naujas priminimas',
    newInvoice: 'Nauja PVM sąskaita',
    sendProforma: {
      title: 'Siųsti išankstinę sąskaitą?'
    },
    sendInvoice: {
      title: (id: string) => `Siųsti sąskaitą NR. ${id}?`
    }
  },
  clientTable: {
    columns: {
      id: 'ID',
      companyInfo: 'Įmonės informacija',
      contactInfo: 'Kontaktinė informacija',
      clientState: 'Kliento būsena',
      responsiblePerson: 'Atsakingas asmuo'
    },
    labels: {
      company: 'Įmonė',
      companyCode: 'Įmonės kodas',
      vatCode: 'PVM kodas',
      address: 'Adresas',
      phone: 'Tel. nr.',
      email: 'El. paštas',
      validFrom: 'Prenumerata nuo',
      validTo: 'Prenumerata iki',
      state: 'Būsena'
    },
    actions: {
      view: 'Peržiūrėti klientą',
      delete: 'Ištrinti klientą',
      deleteConfirm: (name: string) => `Ar tikrai ištrinti ${name}?`,
      deleteSuccess: 'Klientas sėkmingai ištrintas'
    },
    states: {
      PAST: 'Buvęs',
      ACTIVE: 'Aktyvus',
      DEAD: 'Neaktyvus',
      COMATOSE: 'Tarpinis',
      HIDDEN: 'Paslėptas',
      SPECIAL: 'Ypatingas',
      OTHER: 'Kitas'
    },
    noData: 'Klientų nėra'
  },
  clientTableAccordion: {
    selectedClients: (count: number) => `Pasirinkti klientai: ${count}`,
    ariaControls: 'panel1c-content',
    headerId: 'panel1c-header'
  },
  clientFilterForm: {
    filter: 'Filtras',
    validFrom: 'Prenumerata nuo',
    validTo: 'Prenumerata iki',
    idFrom: 'ID nuo',
    idTo: 'ID iki',
    clientIdList: 'Klientų ID sąrašas:',
    actions: {
      filter: 'Filtruoti',
      clear: 'Išvalyti',
      addId: 'Pridėti ID',
      removeId: 'Išimti ID'
    }
  },
  clientEmailSelect: {
    recipients: 'Gavėjai',
    mainEmail: 'Pagrindinis el. paštas'
  },
  clientForm: {
    save: 'Išsaugoti',
    errors: {
      loadClient: 'Failed to load client data',
      server: 'Serverio klaida'
    },
    success: {
      saved: 'Klientas sėkmingai išsaugotas'
    }
  },
  emailRecipientsTable: {
    title: "Išsiųsti laiškai",
    columns: {
      clientId: "Klientas",
      email: "Gavėjas",
      date: "Data",
      status: "Statusas",
      error: "Klaida",
      opened: "Atidarytas"
    },
    statusOptions: {
      SENT: "Išsiųsta",
      ERROR: "Klaida"
    },
    noError: "Nėra",
    noData: "Nėra duomenų"
  },
  emailResultsTable: {
    title: "Išsiųsti laiškai",
    columns: {
      senderName: "Siuntėjas",
      filter: "Filtras",
      status: "Statusas",
      finishedAt: "Siuntimo pabaigos laikas",
      sentCount: "Išsiųsti laiškai",
      failedCount: "Neišsiųsti laiškai",
      invoiceSent: "Sąskaita siųsta"
    },
    filterLabels: {
      filter: "Filtras",
      state: "Statusas",
      validFrom: "Prenumeratos pabaiga nuo",
      validTo: "Prenumeratos pabaiga iki",
      idFrom: "Id nuo",
      idTo: "Id iki"
    },
    status: {
      PROCESSING: "Siunčiamas",
      FINISHED: "Išsiųstas"
    },
    invoiceSent: {
      true: "Taip",
      false: "Ne"
    },
    actions: {
      viewRecipients: "Peržiūrėti gavėjus"
    }
  },
  fileSelector: {
    dropzoneText: "Įtempkite arba pasirinkite failą",
    previewText: "Pridėti failai:",
  },
  invoiceEmailModalForm: {
    emailSent: "Laiškas išsiųstas",
    editor: {
      importantEmail: "Svarbus laiškas",
      fontFormats: "Arial=arial,helvetica,sans-serif;Times New Roman=times new roman,times",
      contentStyle: "body { font-family: Times New Roman; }"
    },
    buttons: {
      previewInvoice: "Peržiūrėti sąskaitą",
      close: "Uždaryti",
      send: "Siųsti"
    },
    validation: {
      contentRequired: "Turinys yra privalomas",
      subjectRequired: "Laiško tema yra privaloma",
      recipientsRequired: "Bent vienas el. pašto adresas yra reikalingas"
    }
  },
  tiptapEditor: {
    placeholder: "Rašykite čia...",
    tooltips: {
      bold: "Paryškinti",
      italic: "Kursyvas",
      underline: "Pabraukti",
      strikethrough: "Perbraukti",
      alignLeft: "Lygiuoti kairėje",
      alignCenter: "Centruoti",
      alignRight: "Lygiuoti dešinėje",
      alignJustify: "Abipusis lygiavimas",
      bulletList: "Sąrašas",
      numberedList: "Numeruotas sąrašas",
      link: "Įterpti nuorodą",
      image: "Įterpti paveikslėlį",
      code: "Kodas",
      importantEmail: "Svarbus laiškas",
      fullscreen: "Pilnas ekranas",
      exitFullscreen: "Išeiti iš pilno ekrano",
      undo: "Atšaukti",
      redo: "Grąžinti"
    },
    fontFamily: "Šriftas",
    fontSize: "Dydis",
    textFormat: "Formatas",
    formats: {
      paragraph: "Paragrafas",
      heading1: "Antraštė 1",
      heading2: "Antraštė 2",
      heading3: "Antraštė 3",
      heading4: "Antraštė 4",
      heading5: "Antraštė 5",
      heading6: "Antraštė 6",
      codeBlock: "Kodo blokas"
    },
    fontSizes: {
      "8pt": "8pt",
      "10pt": "10pt",
      "12pt": "12pt",
      "14pt": "14pt",
      "18pt": "18pt",
      "24pt": "24pt",
      "36pt": "36pt"
    },
    dialogs: {
      link: {
        title: "Įterpti nuorodą",
        urlLabel: "URL",
        cancelButton: "Atšaukti",
        insertButton: "Įterpti"
      },
      image: {
        title: "Įterpti paveikslėlį",
        urlLabel: "Paveikslėlio URL",
        cancelButton: "Atšaukti",
        insertButton: "Įterpti"
      }
    }
  },
  invoice: {
    form: {
      title: "Sąskaitos forma",
      fields: {
        companyTitle: "Įmonės pavadinimas",
        companyCode: "Įmonės kodas",
        companyVatCode: "Įmonės PVM mokėtojo kodas",
        companyAddress: "Įmonės adresas",
        companyEmail: "El. paštas",
        companyPhone: "Telefono numeris",
        date: "Data",
        periodFrom: "Prenumerata nuo",
        periodTo: "Prenumerata iki",
        price: "Kaina",
        discount: "Nuolaida",
        jobTitle: "Išrašęs asmuo",
        product: "Produktas",
        productPeriod: "Produkto laikotarpis"
      },
      buttons: {
        preview: "Peržiūrėti sąskaitą",
        cancel: "Atšaukti",
        save: "Išsaugoti"
      },
      success: "Sąskaita išsaugota sėkmingai"
    },
    table: {
      title: "Sąskaitos",
      columns: {
        clientId: "Kliento ID",
        date: "Išrašymo data",
        invoiceNo: "Sąskaitos Nr.",
        companyTitle: "Įmonės pavadinimas",
        periodFrom: "Prenumerata nuo",
        periodTo: "Prenumerata iki",
        price: "Kaina",
        pvm: "PVM",
        discount: "Nuolaida",
        totalCount: "Viso",
        lastSentDate: "Siuntimo data",
        author: "Autorius"
      },
      actions: {
        print: "Spausdinti sąskaitą",
        edit: "Redaguoti sąskaitą",
        view: "Peržiūrėti sąskaitą",
        send: "Siųsti sąskaitą",
        delete: "Ištrinti sąskaitą",
        deleteConfirm: "Ar tikrai ištrinti sąskaitą?"
      },
      noInvoices: "Klientas neturi sąskaitų"
    },
    filter: {
      dateFrom: "Prenumerata nuo",
      dateTo: "Prenumerata iki",
      author: "Išrašęs asmuo",
      buttons: {
        filter: "Filtruoti",
        clear: "Išvalyti"
      }
    },
    modalView: {
      title: "Sąskaita",
      browserNotSupported: "Naršyklė nepalaiko PDF peržiūros!",
      close: "Uždaryti",
      send: "Siųsti"
    }
  },
  managers: {
    title: "Vadybininkai",
    columns: {
      username: "Vartotojo Vardas",
      firstName: "Vardas",
      lastName: "Pavardė",
      email: "El. paštas",
      authEmail: "Prisijungimo el. paštas",
      userType: "Vartotojo tipas",
      status: "Statusas"
    },
    userTypes: {
      ADMIN: "Administratorius",
      USER: "Vadybininkas"
    },
    status: {
      active: "Aktyvus",
      inactive: "Neaktyvus"
    },
    actions: {
      resetPassword: "Atstatyti slaptažodį",
      edit: "Redaguoti vadybininką",
      delete: "Ištrinti vadybininką",
      newManager: "Naujas vadybininkas"
    },
    confirmations: {
      resetPasswordTitle: "Atstatyti slaptažodį?",
      resetPasswordBody: (name: string) => `Ar tikrai atstatyti ${name} slaptažodį?`,
      resetPasswordAction: "Atstatyti",
      deleteTitle: "Ištrinti vadybininką?",
      deleteBody: (firstName: string, lastName: string) => `Ar tikrai norite ištrinti ${firstName} ${lastName} iš sistemos?`,
      deleteAction: "Ištrinti"
    },
    notifications: {
      resetSuccess: {
        title: "Atstatyta",
        message: "Slaptažodžio atstatymo laiškas išsiųstas"
      },
      resetError: {
        title: "Klaida",
        message: "Nepavyko atstatyti slaptažodžio"
      },
      deleteSuccess: {
        title: "Ištrinta",
        message: "Vadybininkas ištrintas sėkmingai"
      },
      deleteError: {
        title: "Klaida",
        message: "Nepavyko ištrinti vadybininko"
      },
      saveSuccess: {
        title: "Išsaugota",
        message: "Sėkmingai išsaugota"
      }
    },
    form: {
      title: "Vadybininko forma",
      personalInfo: "Asmeninė informacija",
      fields: {
        username: "Vartotojo vardas",
        email: "El pašto adresas",
        auth: "Prisijungimo el. pašto adresas",
        userType: "Vartotojo tipas",
        firstName: "Vardas",
        lastName: "Pavardė",
        active: "Aktyvus"
      },
      buttons: {
        cancel: "Atšaukti",
        save: "Išsaugoti"
      },
      validation: {
        emailRequired: 'El. paštas yra privalomas',
        emailInvalid: 'Neteisingas el. pašto formatas',
        userTypeRequired: 'Naudotojo tipas yra privalomas',
        firstNameRequired: 'Vardas yra privalomas',
        lastNameRequired: 'Pavardė yra privaloma',
        usernameRequired: 'Naudotojo vardas yra privalomas',
        activeRequired: 'Aktyvumo statusas yra privalomas'
      }
    }
  },
  subjects: {
    form: {
      title: "Laiško tema",
      fields: {
        subject: "Laiško tema"
      },
      buttons: {
        cancel: "Atšaukti",
        save: "Išsaugoti"
      },
      validation: {
        subjectRequired: "Tema yra privaloma!"
      },
      notifications: {
        success: {
          message: "Laiško tema išsaugota sėkmingai"
        }
      }
    },
    table: {
      title: "Laiškų temos",
      columns: {
        id: "ID",
        subject: "Tema"
      },
      actions: {
        add: "Pridėti temą",
        edit: "Redaguoti temą",
        delete: "Ištrinti temą"
      },
      confirmations: {
        deleteTitle: "Ištrinti temą?",
        deleteBody: "Ar tikrai ištrinti temą?",
        deleteAction: "Ištrinti"
      },
      notifications: {
        deleteSuccess: "Tema sėkmingai ištrinta"
      },
      noData: "Temų nėra"
    }
  },
  accessRules: {
    form: {
      title: "Taisyklė",
      fields: {
        userId: "Vartotojo ID",
        ipAddresses: "IP adresai",
        browserIds: "Naršyklių ID",
        enabled: "Aktyvus"
      },
      buttons: {
        cancel: "Atšaukti",
        save: "Išsaugoti",
        add: "Pridėti"
      },
      validation: {
        userIdRequired: "Vartotojo ID yra privalomas"
      },
      notifications: {
        success: {
          message: "Taisyklė išsaugota sėkmingai"
        }
      }
    },
    table: {
      title: "Prisijungimų taisyklės",
      columns: {
        id: "ID",
        userId: "Vartotojas",
        ipAddresses: "IP adresai",
        browserIds: "Naršyklių ID",
        enabled: "Aktyvus"
      },
      actions: {
        add: "Pridėti taisyklę",
        edit: "Redaguoti taisyklę",
        delete: "Ištrinti taisyklę"
      },
      confirmations: {
        deleteTitle: "Ištrinti taisyklę?",
        deleteBody: "Ar tikrai ištrinti taisyklę?",
        deleteAction: "Ištrinti"
      },
      notifications: {
        deleteSuccess: "Taisyklė sėkmingai ištrinta",
        updateSuccess: "Taisyklė sėkmingai atnaujinta",
        updateError: "Nepavyko atnaujinti taisyklės"
      },
      noData: "Taisyklių nėra"
    }
  },
  accessLogs: {
    table: {
      title: "Prisijungimai",
      columns: {
        userId: "Vartotojas",
        ipAddress: "IP adresas",
        clientName: "Naršyklė",
        accessTime: "Prisijungimo laikas",
      },
      filters: {
        selectManager: "Pasirinkite vartotoją",
        allManagers: "Visi vartotojai"
      },
      noData: "Nėra duomenų",
    },
    filter: {
      userId: "Vartotojo ID"
    }
  },
  reminders: {
    table: {
      title: "Priminimai",
      columns: {
        companyTitle: "Klientas",
        clientId: "Kliento ID",
        date: "Data",
        clientState: "Kliento statusas",
        comment: "Komentaras"
      },
      actions: {
        view: "Peržiūrėti klientą",
        edit: "Redaguoti priminimą",
        delete: "Ištrinti priminimą"
      },
      confirmations: {
        deleteTitle: "Ištrinti priminimą?",
        deleteBody: (companyTitle: string) => `Ar tikrai ištrinti priminimą klientui ${companyTitle}?`,
        deleteAction: "Ištrinti"
      },
      notifications: {
        deleteSuccess: "Priminimas sėkmingai ištrintas",
        deleteError: "Nepavyko ištrinti priminimo"
      },
      noData: "Priminimų nėra"
    },
    filter: {
      companyFilter: "Filtras",
      dateFrom: "Prenumerata nuo",
      dateTo: "Prenumerata iki",
      clientState: "Kliento statusas"
    },
    form: {
      title: "Priminimų forma",
      fields: {
        date: "Data",
        comment: "Komentaras"
      },
      buttons: {
        cancel: "Atšaukti",
        save: "Išsaugoti"
      },
      validation: {
        dateRequired: "Data yra privaloma",
        commentRequired: "Komentaras yra privalomas"
      },
      notifications: {
        success: {
          message: "Priminimas išsaugotas sėkmingai"
        },
        error: {
          message: "Nepavyko išsaugoti priminimo"
        }
      }
    },
    clientStates: {
      PAST: "Buvęs",
      ACTIVE: "Aktyvus",
      DEAD: "Neaktyvus",
      COMATOSE: "Tarpinis",
      HIDDEN: "Paslėptas",
      SPECIAL: "Ypatingas",
      OTHER: "Kitas"
    }
  },
  datePickerLabels: {
    date: "Data",
    periodFrom: "Prenumerata nuo",
    periodTo: "Prenumerata iki"
  }
} as const;
